import { getClirnetSurveys, getClirnetSurveyOptions, stripHtml, parseSpq } from '../../survey/clirnetSurvey/index.js';
// surveyUtil.js, not the index: the index also exports the renderer, which pulls in SurveyJS.
import { getSurveyJsFirstElement } from '../../survey/surveyJs/surveyUtil.js';
import { getPollPoints } from '../../utils/pollTypes.js';

// HTML -> plain text with entities decoded (&nbsp; -> space, &amp; -> &). DOMParser
// builds an inert document, so nothing in the HTML runs. Used for comparisons only;
// the card renders the HTML itself (sanitized) via RichText in PollPage.jsx.
function htmlToText(html) {
  if (html == null || html === '') return '';
  try {
    const text = new DOMParser().parseFromString(String(html), 'text/html').body.textContent || '';
    return text.replace(/\s+/g, ' ').trim();
  } catch {
    return stripHtml(html);
  }
}

export function usePollCard(poll, idx) {
  const schema = poll && typeof poll.question === 'object' && poll.question !== null ? poll.question : undefined;
  const isSurveyJs = poll.type === 'SurveyJs' && schema;
  const isPollNew = poll.type === 'poll' || poll.category === 'poll';
  const isSurveyNew = poll.type === 'survey' || poll.category === 'survey';
  const newSchema = poll.data && typeof poll.data === 'object' ? poll.data : null;
  const clirnetSchema = parseSpq(poll?.spq) ?? (typeof poll?.question === 'object' && poll.question !== null ? poll.question : newSchema || undefined);
  const isClirnet = (poll.type === 'clirnetSurvey' && clirnetSchema) || ((isPollNew || isSurveyNew) && newSchema);

  const surveys = isClirnet ? getClirnetSurveys(newSchema || clirnetSchema) : [];
  const total = surveys.length;
  const safe = Math.min(idx, Math.max(total - 1, 0));
  const current = surveys[safe];

  const el = isSurveyJs ? getSurveyJsFirstElement(schema) : null;
  const qText = isClirnet ? htmlToText(current?.question) : '';
  const title = isSurveyJs ? htmlToText(el?.title) : isClirnet ? qText || htmlToText(poll.title) : htmlToText(poll.question || poll.title);
  // Original HTML of the question, for rendering (title above is its plain-text form).
  const titleHtml = isSurveyJs
    ? String(el?.title ?? '')
    : isClirnet
      ? (qText ? String(current?.question ?? '') : String(poll.title ?? ''))
      : String((typeof poll.question === 'string' ? poll.question : '') || poll.title || '');
  const options = isClirnet
    ? getClirnetSurveyOptions(current).map((o, i) => ({ id: `opt_${i + 1}`, text: o.label, value: 0 }))
    : poll.options;
  const points = getPollPoints(poll);
  const pollTitleText = htmlToText(poll.title);

  return { isSurveyJs, isPollNew, isSurveyNew, isClirnet, surveys, total, safe, current, title, titleHtml, pollTitleText, options, points, qText, el };
}
